import Api from './axios';

// Lists take the filters documented in social/rest/ads.py and return { count, next, previous, results }
export const EXPORTS = {
  connections: 'social/connections/export/',
  accounts: 'ads/accounts/export/',
  campaigns: 'ads/campaigns/export/',
  adsets: 'ads/adsets/export/',
  ads: 'ads/ads/export/',
  insights: 'ads/insights/export/',
  daily: 'ads/insights/export/daily/',
  topAds: 'ads/insights/export/top-ads/',
};

const AdsApi = {
  accounts: (params) => Api.get('/ads/accounts/', { params }),
  updateAccount: (id, data) => Api.patch(`/ads/accounts/${id}/`, data),
  // everything in one ad account, in the background; the list's is_syncing and last_sync_failed follow it
  syncAccount: (id) => Api.post(`/ads/accounts/${id}/sync/`),
  campaigns: (params) => Api.get('/ads/campaigns/', { params }),
  adsets: (params) => Api.get('/ads/adsets/', { params }),
  ads: (params) => Api.get('/ads/ads/', { params }),
  // status filter groups: { results: [{ value, label, tone }] }; type 'ad_account' for ad account statuses
  statuses: (type) => Api.get('/ads/statuses/', { params: type ? { type } : {} }),
  insights: (params) => Api.get('/ads/insights/', { params }),
  // a plain link: the browser downloads the file with the session cookie. path is one of EXPORTS, file csv or xlsx
  exportUrl: (path, params, file) => `/api/${path}?${new URLSearchParams({ ...params, file })}`,
};

export default AdsApi;
